module.exports = __webpack_public_path__ + "img/logo.d4b5bf4.png";